import React, {useRef, useState} from 'react';
import {Modal} from "../../../../../../components/modal/modal.jsx";
import {AgGridReact} from "ag-grid-react";
import projectUtils from "../../../../../../utils/project-utils.js";
import {FaEye} from "react-icons/fa";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import Button from "../../../../../../components/button/button.jsx";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const EcapHistoryModal = ({open, setOpen, history}) => {
    const gridRef = useRef(undefined);

    const [columnDefs,] = useState([
        {headerName: "Data/hora", field: "created_at", flex: 1, sort: "desc", valueFormatter: ({value}) => projectUtils.formatDate(value)},
        {headerName: "Gerado por", field: "user_name", flex: 1},
        {
            headerName: "",
            field: "",
            cellRenderer: ({node}) => (
                <div className="flex items-center justify-center w-full h-full">
                    <Button onClick={() => window.open(`${API_KEEPER}/ged/attach/print/pdf/${node.data.ged_id}`, node.data.ged_id)}>
                        <FaEye />
                    </Button>
                </div>
            ),
            width: 80
        }
    ])

    return (
        <Modal open={open} setOpen={setOpen} title={"Histórico"}>
            <Modal.Body>
                <div style={{height: "calc(100vh - 240px)"}}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={history}
                        columnDefs={columnDefs}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        theme={aggridUtils.generalTheme({rowHeight: 40})}
                        suppressRowVirtualisation={true}
                        suppressColumnVirtualisation={true}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => setOpen(false)}>
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EcapHistoryModal;